// extracted by mini-css-extract-plugin
export default {"card_container":"Royalties_card_container__Co2Aa","logo":"Royalties_logo__qrWyx","sheet":"Royalties_sheet__VbSzb","label":"Royalties_label__-K2+x","value":"Royalties_value__0cTko"};